/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Campaignservicev1OrderLine } from '../models/Campaignservicev1OrderLine';
import { HttpFile } from '../http/http';

export class V1BatchUpdateOrderLinesResponse {
    /**
    * Order Lines updated.
    */
    'orderLines'?: Array<Campaignservicev1OrderLine>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLines",
            "baseName": "order_lines",
            "type": "Array<Campaignservicev1OrderLine>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1BatchUpdateOrderLinesResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

